import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const NotFound = () => {
  return (
    <Container maxW="container.xl" py={8} mt="120px">
      <VStack spacing={8} textAlign="center" py={20}>
        <Heading as="h1" size="4xl">
          404
        </Heading>
        <Heading as="h2" size="xl">
          Page Not Found
        </Heading>
        <Text fontSize="xl">
          The page you are looking for doesn't exist or has been moved.
        </Text>
        <Button
          as={RouterLink}
          to="/"
          colorScheme="blue"
          size="lg"
          leftIcon={<FaHome />}
        >
          Back to Home
        </Button>
      </VStack>
    </Container>
  );
};

export default NotFound;






